export default {
  data() {
    return {
      submitting: false,
    };
  },
  methods: {
    /**
     * Generic method to handle form submission with validation
     * @param {Function} validateFn - Function to validate the form
     * @param {Function} submitFn - Function to submit the form data
     * @param {Object} formData - Form data to submit
     * @param {Object} options - Additional options
     * @returns {Promise<any>} - Promise resolving to the submission result
     */
    async handleSubmit(validateFn, submitFn, formData, options = {}) {
      const {
        successMessage = 'Thao tác thành công',
        errorMessage = 'Có lỗi xảy ra',
        redirectRoute = null,
        redirectParams = {},
        showSuccessToast = true,
        resetForm = false,
      } = options;

      const isValid = validateFn ? await validateFn(formData) : true;
      if (!isValid) return;

      this.submitting = true;
      try {
        const result = await submitFn(formData);

        if (showSuccessToast) {
          this.makeToastSuccess && this.makeToastSuccess(successMessage);
        }

        if (resetForm) {
          this.resetForm && this.resetForm();
        }

        if (redirectRoute) {
          this.$router.push({
            name: redirectRoute,
            params: redirectParams,
          });
        }

        return result;
      } catch (error) {
        this.handleError && this.handleError(error, errorMessage);
      } finally {
        this.submitting = false;
      }
    },

    /**
     * A basic implementation of toast success
     * @param {string} message - Success message to display
     */
    makeToastSuccess(message) {
      if (this.$bvToast) {
        this.$bvToast.toast(message, {
          title: 'Thành công',
          variant: 'success',
          solid: true,
        });
      } else {
        console.log('[Success]', message);
      }
    },

    /**
     * A basic implementation of error handling
     * @param {Error} error - Error object
     * @param {string} fallbackMessage - Fallback error message
     */
    handleError(error, fallbackMessage = 'Có lỗi xảy ra') {
      const errorMessage = error?.message || fallbackMessage;

      if (this.$bvToast) {
        this.$bvToast.toast(errorMessage, {
          title: 'Lỗi',
          variant: 'danger',
          solid: true,
        });
      } else {
        console.error('[Error]', error);
        console.log('[Error Message]', errorMessage);
      }
    },
  },
};
